import { IconProps } from '@va/icons';

export const ManualSnippetInstallationIcon = ({ className }: IconProps) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <circle cx='9' cy='8.99915' r='5.25' stroke='black' strokeWidth='1.5' />
      <path
        d='M15.4393 17.5598C16.0251 18.1456 16.9749 18.1456 17.5607 17.5598C18.1464 16.974 18.1464 16.0243 17.5607 15.4385L16.5 16.4991L15.4393 17.5598ZM16.5 16.4991L17.5607 15.4385L15.3107 13.1885L14.25 14.2491L13.1893 15.3098L15.4393 17.5598L16.5 16.4991Z'
        fill='black'
      />
      <path
        opacity='0.5'
        d='M13.5 -0.000976562C15.9851 -0.000976562 17.9998 2.01392 18 4.49902V9.74902C18 10.3948 17.8363 11.0027 17.5488 11.5332C17.2851 10.9911 16.9151 10.5107 16.4668 10.1172C16.4865 9.99735 16.5 9.87445 16.5 9.74902V4.49902C16.4998 2.84235 15.1567 1.49902 13.5 1.49902H4.5C2.84328 1.49902 1.50021 2.84235 1.5 4.49902V13.499C1.5 15.1559 2.84315 16.499 4.5 16.499H9.75C9.87553 16.499 9.99823 16.4866 10.1182 16.4668C10.5116 16.9148 10.9923 17.2842 11.5342 17.5479C11.0035 17.8355 10.396 17.999 9.75 17.999H4.5C2.01472 17.999 0 15.9843 0 13.499V4.49902C0.000214395 2.01392 2.01485 -0.000976562 4.5 -0.000976562H13.5Z'
        fill='black'
      />
      <path opacity='0.5' d='M8.25 6.74915H9.75' stroke='black' strokeWidth='1.5' strokeLinecap='round' />
      <path opacity='0.5' d='M6.75 8.99915H11.25' stroke='black' strokeWidth='1.5' strokeLinecap='round' />
      <path opacity='0.5' d='M8.25 11.2491H9.75' stroke='black' strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
};

export const NativeSnippetIcon = ({ className }: IconProps) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 1.5H5.25C6.07843 1.5 6.75 2.17157 6.75 3V5.25C6.75 6.07843 6.07843 6.75 5.25 6.75H3C2.17157 6.75 1.5 6.07843 1.5 5.25V3C1.5 2.17157 2.17157 1.5 3 1.5ZM0 3C0 1.34315 1.34315 0 3 0H5.25C6.90685 0 8.25 1.34315 8.25 3V5.25C8.25 6.90685 6.90685 8.25 5.25 8.25H3C1.34315 8.25 0 6.90685 0 5.25V3ZM12.75 1.5H15C15.8284 1.5 16.5 2.17157 16.5 3V5.25C16.5 6.07843 15.8284 6.75 15 6.75H12.75C11.9216 6.75 11.25 6.07843 11.25 5.25V3C11.25 2.17157 11.9216 1.5 12.75 1.5ZM9.75 3C9.75 1.34315 11.0931 0 12.75 0H15C16.6569 0 18 1.34315 18 3V5.25C18 6.90685 16.6569 8.25 15 8.25H12.75C11.0931 8.25 9.75 6.90685 9.75 5.25V3ZM5.25 11.25H3C2.17157 11.25 1.5 11.9216 1.5 12.75V15C1.5 15.8284 2.17157 16.5 3 16.5H5.25C6.07843 16.5 6.75 15.8284 6.75 15V12.75C6.75 11.9216 6.07843 11.25 5.25 11.25ZM3 9.75C1.34315 9.75 0 11.0931 0 12.75V15C0 16.6569 1.34315 18 3 18H5.25C6.90685 18 8.25 16.6569 8.25 15V12.75C8.25 11.0931 6.90685 9.75 5.25 9.75H3ZM13.125 17.25V14.625H10.5C10.0858 14.625 9.75 14.2892 9.75 13.875C9.75 13.4608 10.0858 13.125 10.5 13.125H13.125V10.5C13.125 10.0858 13.4608 9.75 13.875 9.75C14.2892 9.75 14.625 10.0858 14.625 10.5V13.125H17.25C17.6642 13.125 18 13.4608 18 13.875C18 14.2892 17.6642 14.625 17.25 14.625H14.625V17.25C14.625 17.6642 14.2892 18 13.875 18C13.4608 18 13.125 17.6642 13.125 17.25Z'
        fill='black'
      />
    </svg>
  );
};
